import { createSlice } from '@reduxjs/toolkit';
import { getSubscriptionsList } from './app.actions';

const initialState = {
  appTitle: '',

  subscriptions: [],
  isLoadingSubscriptions: false
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppTitle: (state, action) => {
      state.appTitle = action.payload;
    },
    clearappState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(getSubscriptionsList.pending, (state) => {
      state.isLoadingSubscriptions = true;
    });
    builder.addCase(getSubscriptionsList.fulfilled, (state, action) => {
      state.subscriptions = action.payload;
      state.isLoadingSubscriptions = false;
    });
    builder.addCase(getSubscriptionsList.rejected, (state) => {
      state.isLoadingSubscriptions = false;
    });
  }
});

export const { setAppTitle, clearappState } = appSlice.actions;

export default appSlice.reducer;
